/*
 * -----------------------------------------------------------------------
 *  <copyright file="grid-pager/index.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import Pagination from '../pagination';
import './styles.scss';

interface GridPagerProps {
    page: number;
    onChange: (number: number) => void;
    numPages: number;
}

const GridPager = ({ page, onChange, numPages }: GridPagerProps) => (
    <div className="grid-pager">
        <div className="grid-pager__item">
            <Pagination currentPage={page} totalPages={numPages} onChange={onChange} />
        </div>
    </div>
);

export default GridPager;
